import type { ComponentProps } from 'react'
import type { Severity } from '../data/alerts/types.ts'
import { Box } from './Box.tsx'

export const RingPreview = ({ variant, ...props }: { variant: Severity | 'hail' | 'clear' } & ComponentProps<typeof Box>) => (
	<Box
		height={24}
		minHeight={24}
		width={24}
		minWidth={24}
		border={`${borderWidth[variant]}px ${variant === 'clear' ? 'dashed' : 'solid'}`}
		borderRadius='50%'
		borderColor={`alerts.${variant}`}
		{...props}
	/>
)

const borderWidth = { hail: 6, alarm: 6, warning: 4, info: 3, clear: 2 }
